import { ref } from "vue";
import { defineStore } from "pinia";
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "tokenResetTimestamp";

export const useTokenResetTimestampStore = defineStore(
  key,
  () => {
    // state

    const tokenResetTimestamp = ref(null);

    // actions

    const set = (value) => {
      tokenResetTimestamp.value = value;
    };

    const unset = () => {
      tokenResetTimestamp.value = null;
    };

    return {
      tokenResetTimestamp,
      set,
      unset,
    };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
